import { computed, ref } from 'vue'
import { useClipboard } from '@vueuse/core'

import type { ComputedRef, Ref } from 'vue'
import type { BtnLinkCopyProps } from '../types/interfaces'

interface BtnLinkCopyOptions {
  props: BtnLinkCopyProps
}

interface BtnLinkCopyReturn {
  refIsSupported: Ref<boolean>
  refTooltipText: ComputedRef<string>
  setCopy: () => void
}

export const useBtnLinkCopy = ({ props }: BtnLinkCopyOptions): BtnLinkCopyReturn => {
  const source = ref<string>(props.linkUrl)
  const { copy, copied, isSupported } = useClipboard({ source })

  const refTooltipText = computed<string>(() => {
    if (copied.value) return 'Link copied'
    return props.tooltipText ?? ''
  })

  const setCopy = (): void => {
    copy(source.value)
  }

  return {
    refIsSupported: isSupported,
    refTooltipText,
    setCopy,
  }
}
